import { render, staticRenderFns } from "./PageNewVehicleRunning.vue?vue&type=template&id=59a9773c"
import script from "./PageNewVehicleRunning.vue?vue&type=script&lang=js"
export * from "./PageNewVehicleRunning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports